<template>
  <div style="height:100%;">
    <layout-login>
      <h1>{{ $t('message["638"]') }}</h1>
      <template v-if="!hasRegister">
        <cube-form
          :model="model"
          :options="options"
          @validate="validateHandler"
          @submit.prevent="submitHandler"
        >
          <cube-form-item :field="fields[0]" />
          <div class="cube-form-item-box">
            <cube-form-item :field="fields[1]" />
            <div class="find-pwd-box">
              <get-code
                class="find-pwd-link"
                :mobile="model.mobile"
                type="11"
                :is-disabled="false"
                @getRes="getRes"
              />
            </div>
          </div>
          <cube-form-group>
            <cube-button
              type="submit"
              :primary="true"
            >
              {{ $t('message["597"]') }}
            </cube-button>
          </cube-form-group>
        </cube-form>
        <p class="reg-login-btn">
          <router-link :to="{name: 'AccountLogin'}">
            {{ $t('message["1484"]') }}
          </router-link>
        </p>
        <a
          href="javascript:;"
          class="m-lang-change"
          @click="changeLanguage"
        >
          {{ langTxt }}
          <i class="iconfont iconchange" />
        </a>
      </template>
      <template v-else>
        <div class="has-regtister-tip">
          <h3>{{ $t('message["1117"]') }}</h3>
          <p>{{ resisterTipTxt[0] }}<br> {{ resisterTipTxt[1] }}</p>
          <cube-button
            type="submit"
            :primary="true"
            @click="loginNow"
          >
            {{ $t('message["595"]') }}
          </cube-button>
          <div class="back-register">
            <a
              href="javascript:;"
              @click="hasRegister=false"
            >{{ $t('message["282"]') }}</a>
          </div>
          <div
            ref="footer"
            class="footer"
          />
        </div>
      </template>
    </layout-login>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import GetCode from '@/components/mobile/GetCode'
import LayoutLogin from '@/components/mobile/account/LayoutLogin'
import { setAuth, getLang } from '@/lib/storage'
export default {
  components: {
    GetCode,
    LayoutLogin
  },
  data () {
    return {
      hasRegister: false,
      auth: '',
      options: {
        scrollToInvalidField: true,
        layout: 'classic' // classic fresh
      },
      validity: {},
      valid: undefined,
      model: {
        mobile: '',
        checkcode: ''
      },
      fields: [
        {
          type: 'input',
          modelKey: 'mobile',
          label: '',
          props: {
            placeholder: this.$t('message["1112"]'),
            maxlength: 11
          },
          rules: {
            required: true,
            type: 'tel'
          }
        },
        {
          type: 'input',
          modelKey: 'checkcode',
          label: '',
          props: {
            placeholder: this.$t('message["1433"]')
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('account/register', ['submitting', 'decorators']),
    resisterTipTxt () {
      return this.$t('message["684"]').split('|')
    },
    lang () {
      return this.getLang()
    },
    langTxt () {
      const { lang } = this
      const isZh = lang === 'zh'
      return isZh ? 'English' : 'Chinese'
    }
  },
  methods: {
    ...mapActions('account/register', ['register']),
    getLang,
    changeLanguage (type) {
      this.$getLanguage()
    },
    async submitHandler (e) {
      const obj = Object.assign(this.model, { checkuserid: this.checkuserid })
      const chain = await this.register()
      chain.params(obj)
        .onSuccess(raw => {
          if (raw.isreg === 1) {
            this.auth = raw.Authorization
            this.hasRegister = true
          } else {
            this.$router.push({ name: 'AccountSetUser', query: { mobile: this.model.mobile, ensecret: raw.ensecret } })
          }
        })
        .onNetSuccess((res) => {
          // console.log(res.data.message)
          // console.log(res)
          const toast = this.$createToast({
            time: 2000,
            txt: res.data.message || res.data.payload[0].message,
            type: 'txt'
          })
          toast.show()
        })
        .setForm(this.form)
        .fetch()
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    },
    getRes (payload) {
      this.checkuserid = payload.checkuserid
    },
    loginNow () {
      setAuth(this.auth)
      this.$store.commit('setAuth', this.auth, { root: true })
      this.$router.push({ name: 'AccountInfo' })
    }
  }
}
</script>
<style lang="scss" scoped>
  .reg-login-btn {
    text-align: center;
    line-height: 46px;
    margin: 20px 0;
  }
  .has-regtister-tip {
    h3 {
      font-size: 18px;
      padding-bottom: 20px;
    }
    p {
      color: #808080;
      font-size: 14px;
      line-height: 26px;
      margin-bottom: 49px;
    }
    .back-register {
      line-height: 46px;
      margin-top: 20px;
    }
  }
</style>
